module.exports = __webpack_public_path__ + "img/macos-2-tw.24a037e2.gif";